import React, { Component, PropTypes } from 'react';
import './CustomControlPopoverWrapper.scss';

export default class CustomControlPopoverWrapper extends Component {
  static propTypes = {
    alignRight: PropTypes.bool,
    children: PropTypes.node.isRequired,
    closeCustomControl: PropTypes.func,
    coordinatesOfAssociatedElement: PropTypes.shape({
      left: PropTypes.number,
      width: PropTypes.number,
    }),
    width: PropTypes.number.isRequired,
  };

  static defaultProps = {
    alignRight: false,
    closeCustomControl: undefined,
    coordinatesOfAssociatedElement: {},
  };

  handleClose = (event) => {
    const { closeCustomControl } = this.props;
    event.preventDefault();
    closeCustomControl();
  };

  getPopOverLeftPosition() {
    const {
      alignRight,
      coordinatesOfAssociatedElement,
      width,
    } = this.props;
    const iconCenterFromRightInPixels = 25;

    let leftPosition = 'auto';

    if (coordinatesOfAssociatedElement.width && alignRight) {
      leftPosition = ((coordinatesOfAssociatedElement.left + coordinatesOfAssociatedElement.width) - (width / 2)) - iconCenterFromRightInPixels;
    } else if (coordinatesOfAssociatedElement.width) {
      leftPosition = coordinatesOfAssociatedElement.left + ((width - coordinatesOfAssociatedElement.width) / -2);
    }

    return leftPosition;
  }

  render() {
    const {
      children,
      closeCustomControl,
      width,
    } = this.props;

    const style = {
      left: this.getPopOverLeftPosition(),
      width,
    };

    return (
      <div className="custom-control-popover-wrapper" style={style}>
        { closeCustomControl && (
          <button className="custom-control-popover-wrapper__close-button" onClick={this.handleClose} />
        )}
        { children }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CustomControl/CustomControlPopoverWrapper.jsx
 **/